
import { Component, Prop, Vue } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { configStore } from "@/store/store-accessor";
import { getDynamicFieldByShortcode } from "@/lib/dynamic-data/utils";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon, TextInput, DropdownInput }
})
export default class DynamicDataFieldText extends Vue {
  @Prop()
  shortcode!: string;

  @Prop({ default: true })
  icon!: boolean;

  get field() {
    return getDynamicFieldByShortcode(
      configStore.dynamicFields,
      this.shortcode
    );
  }
}
